import { useNutrientList } from 'context/Store';

import NutrientsDisplay from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/Nutrients';
import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import * as Calculation from 'types/Recipe/Calculation';
import * as IngredientList from 'types/Recipe/Detail/ErpNew/IngredientList';
import * as Product from 'types/Recipe/Detail/ErpNew/Product';
import * as NutrientList from 'types/_general/Store/NutrientList';

export const NutrientInformation = (
	props: RecipeErpViewComponentProps & {
		ingredientId: string;
		segmentIndex: number;
		calculation: Calculation.Type;
	}
) => {
	const nutrients = useNutrientList();

	const erpRecipe = props.state.erpRecipes.find((e) => e.id === props.state.erpRecipeId);
	if (!erpRecipe) return <></>;

	const allProducts = IngredientList.getProducts(erpRecipe.ingredients, {
		ingredientId: props.ingredientId,
		segmentIndex: props.segmentIndex,
	});

	const productIdLeft = props.state.comparisonLeft[props.ingredientId];
	const productIdRight = props.state.comparisonRight[props.ingredientId];
	if (!productIdLeft && !productIdRight) return <></>;

	const defaultProduct = IngredientList.getDefaultProduct(
		erpRecipe.ingredients,
		props.ingredientId
	);

	const productLeft: Product.Type | undefined = productIdLeft
		? IngredientList.getProduct(erpRecipe.ingredients, {
				ingredientId: props.ingredientId,
				segmentIndex: props.segmentIndex,
				productId: productIdLeft,
		  })
		: defaultProduct;

	const productRight: Product.Type | undefined = productIdRight
		? IngredientList.getProduct(erpRecipe.ingredients, {
				ingredientId: props.ingredientId,
				segmentIndex: props.segmentIndex,
				productId: productIdRight,
		  })
		: defaultProduct;

	if (!productLeft && !productRight) return <></>;

	return (
		<NutrientsDisplay
			{...props}
			allProducts={allProducts}
			productLeft={productLeft ?? null}
			productRight={productRight ?? null}
			setComparisonLeft={(e: string | null) =>
				props.handlers.setComparisonLeft({
					ingredientId: props.ingredientId,
					productId: e,
				})
			}
			setComparisonRight={(e: string | null) =>
				props.handlers.setComparisonRight({
					ingredientId: props.ingredientId,
					productId: e,
				})
			}
			nutrients={NutrientList.mapToCalculatedNutrient(nutrients)}
		/>
	);
};
